import {
  DefaultPage,
} from './index';

export default {
  path: 'social',
  childRoutes: [
    { path: 'default-page', component: DefaultPage, isIndex: true },
    { path: 'post/:postId', component: DefaultPage },
    { path: ':key', component: DefaultPage },
  ],
};
